<template>
	<a @click.prevent="openBookingEngine({ ...props })">
		<slot />
	</a>
</template>

<script setup lang="ts">
import { BookingEngineFactory } from '@becurioushq/mews';
import type MewsWidget from '@becurioushq/mews';
import type { BookingParameters } from '@becurioushq/mews';

const { locale } = useI18n();
const config = useRuntimeConfig();

const bookingEngine = useState<MewsWidget | null>('bookingEngine', () => null);

const props = defineProps<{
	language?: string;
	arrival?: Date;
	departure?: Date;
	pax?: number;
	promo?: string;
	roomid?: string;
}>();

useHead({
	script: [
		{
			key: 'mews-distributor',
			src: 'https://api.mews.com/distributor/distributor.min.js',
		},
	],
});

const openBookingEngine = (options: BookingParameters) => {
	if (!bookingEngine.value) {
		return;
	}

	if (!options.language) {
		options = { ...options, language: locale.value };
	}

	bookingEngine.value.visitUrl(options);
};

onMounted(() => {
	if (!bookingEngine.value) {
		const factory = new BookingEngineFactory({
			hotelID: config.public.mewsHotelId,
			gtmID: config.public.googleTagManagerId,
			primaryColor: '#a39160',
			mode: 'widget',
		});
		bookingEngine.value = factory.createBookingEngine() as MewsWidget;
	}
});
</script>

<style lang="scss" scoped>
a {
	color: #fff;
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
}
</style>
